import React, { useEffect, useState } from "react";
import { Container, Navbar, Nav, NavDropdown, Image, } from 'react-bootstrap';
import { Link } from "gatsby"

import Logo from '../images/logo_white.png';
import LogoColor from '../images/logo_color.png';

const Header = () => {

    const [showDropdownHover1, setShowDropdown1] = useState(false);

    const showDropdown1 = (e) => { setShowDropdown1(!showDropdownHover1); }
    const hideDropdown1 = e => { setShowDropdown1(false); }

    const [scroll, setScroll] = useState(false)

    useEffect(() => {
        window.addEventListener("scroll", () => {
            setScroll(window.scrollY > 150);
        });
    }, []);

    return (
        <>
            <Navbar variant="light" expand="lg" className={scroll ? "navbar-fixed" : ""}>
                <Container>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Brand>
                        <Link to="/">
                            <Image loading="lazy" className="lazyload logo-white" src={Logo} alt="logo" width={143} height={54} />
                            <Image loading="lazy" className="lazyload logo-color" src={LogoColor} alt="logo" width={143} height={54} />
                        </Link>
                    </Navbar.Brand>
                    <Navbar.Collapse id="basic-navbar-nav" className="order-4 order-lg-3">
                        <Nav className="ms-auto">
                            <Link className="nav-link" to="/about-us"> About Us</Link>
                            <NavDropdown title="Solutions" id="basic-nav-solutions"
                                show={showDropdownHover1}
                                onMouseEnter={showDropdown1}
                                onMouseLeave={hideDropdown1}
                                onClick={showDropdown1}
                            >
                                <Link to="/cooking-gas-delivery-solution" className="dropdown-item">Cooking Gas Delivery solution</Link>
                                <Link to="/fuel-delivery-solution" className="dropdown-item">Fuel Delivery solution</Link>

                            </NavDropdown>
                            {/* <Link className="nav-link" to="/"> Use Case</Link> */}
                            <Link className="nav-link" to="/blog"> Blog</Link>
                        </Nav>
                    </Navbar.Collapse>
                    <div className="order-3 order-lg-4 ms-auto">
                        <Link className="btn contact-btn" to="/contact">Contact</Link>
                    </div>
                </Container>
            </Navbar>
        </>
    );
}

export default Header
